export default __webpack_public_path__ + "static/media/2.243e09c4.jpg";